import { render, staticRenderFns } from "./RegistrationAndLoginSupportError.vue?vue&type=template&id=2c97709c&"
import script from "./RegistrationAndLoginSupportError.vue?vue&type=script&lang=js&"
export * from "./RegistrationAndLoginSupportError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports